import { render, staticRenderFns } from "./GroupedNeedCardList.vue?vue&type=template&id=261aa1ae&"
import script from "./GroupedNeedCardList.vue?vue&type=script&lang=js&"
export * from "./GroupedNeedCardList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "GroupedNeedCardList.vue"
export default component.exports